export default[
    //选择银行卡
    {
        path:'/wellcredito/card',
        name:'cardlist',
        meta:{
            title:'Banco'
        },
        component:()=>import('@/wellcreditoapp/views/card/list/index')
    },
    //添加银行卡
    {
        path:'/wellcredito/card/add',
        name:'bindcard',
        meta:{
            title:'Añadir una tarjeta bancaria'
        },
        component:()=>import('@/wellcreditoapp/views/card/add/index')
    },
    //订单页面
    {
        path:'/wellcredito/order',
        name:'order',
        meta:{
            title:'Detalles del pedido'
        },
        component:()=>import('@/wellcreditoapp/views/order/index/index')
    },
    //展期订单
    {
        path:'/wellcredito/order/delayed/:orderId',
        name:'orderDelayed',
        meta:{
            title:'Extensión de pago'
        },
        component:()=>import('@/wellcreditoapp/views/order/delayed/index')
    },
    //历史订单列表
    {
        path:'/wellcredito/order/history',
        name:'orderhistory',
        meta:{
            title:'Pedidos históricos'
        },
        component:()=>import('@/wellcreditoapp/views/order/history/index')
    },
    //历史订单详情
    {
        path:'/wellcredito/order/history/details/:orderId',
        name:'orderdetails',
        meta:{
            title:'Detalles del pedido'
        },
        component:()=>import('@/wellcreditoapp/views/order/details/index')
    },
    //完成订单
    {
        path:'/wellcredito/order/detail/:orderId/:loanTenureType/:curInstallment',
        name:'detail',
        meta:{
            title:'Detalles del pedido'
        },
        component:()=>import('@/wellcreditoapp/views/order/successes/index')
    },
    //android-客服
    {
        path:'/wellcredito/customer/index',
        name:'customerAndroid',
        meta:{
            title:'Comentarios sobre el servicio'
        },
        component:()=>import('@/wellcreditoapp/views/customer/android/index')
    },
    //IOS-客服
    {
        path:'/wellcredito/customer/ios',
        name:'customerIos',
        meta:{
            title:'Comentarios sobre el servicio'
        },
        component:()=>import('@/wellcreditoapp/views/customer/ios/index')
    },
    //借款协议
    {
        path:'/wellcredito/agreement',
        name:'agreementIndex',
        meta:{
            title:'Acuerdo de Préstamo Personal'
        },
        component:()=>import('@/wellcreditoapp/views/agreement/index/index.vue')
    },
    //FAQ常见问题
    {
        path:'/wellcredito/faq',
        name:'faqIndex',
        meta:{
            title:'FAQ'
        },
        component:()=>import('@/wellcreditoapp/views/faq/index/index.vue')
    },
]



// WEBPACK FOOTER //
// ./src/wellcreditoapp/router/router.js